const _excluded = ["columnSelectorConfig"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { SaveButton } from '../buttons';
import { useTableColumnSelectorConfig } from './useTableColumnSelectorConfig';
import './TableColumnSelector.scss';
import { useTranslation } from 'react-i18next';
import TableColumnSelectorTooltipIcon from './TableColumnSelectorTooltipIcon';
const REQUIRED_COLUMN_TOOLTIP_TEXT = 'this field is required';
const isColumnSelectable = _ref => {
  let {
    columnConfig,
    columnParams
  } = _ref;
  if (typeof (columnConfig === null || columnConfig === void 0 ? void 0 : columnConfig.selectable) !== 'function') return true;
  return !!columnConfig.selectable(columnParams);
};
const TableColumnSelectorContent = _ref2 => {
  let {
    columnConfigByColumnName = {},
    columnParams = {},
    columnSelectorJson,
    columnSelectorSections,
    mergeColumnSelectorJson,
    onSelectedTableConfigChange,
    requiredColumns = [],
    saveTableSetup,
    selectedTableConfig,
    isExpanded
  } = _ref2;
  const [draftColumnsJson, setDraftColumnsJson] = useState(columnSelectorJson);
  const [draggedColumnIndex, setDraggedColumnIndex] = useState(null);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    if (!columnSelectorJson) return;
    setDraftColumnsJson(columnSelectorJson);
  }, [columnSelectorJson]);
  useEffect(() => {
    if (!selectedTableConfig) return;
    if (!onSelectedTableConfigChange) return;
    onSelectedTableConfigChange(selectedTableConfig);
  }, [onSelectedTableConfigChange, selectedTableConfig]);
  const toggleColumn = columnName => {
    if (requiredColumns.includes(columnName)) return;
    if (!isColumnSelectable({
      columnConfig: columnConfigByColumnName[columnName],
      columnParams
    })) return;
    setDraftColumnsJson(currentColumnsJson => {
      const isSelected = currentColumnsJson.selectedColumns.includes(columnName);
      return _objectSpread(_objectSpread({}, currentColumnsJson), {}, {
        selectedColumns: isSelected ? currentColumnsJson.selectedColumns.filter(selectedColumn => selectedColumn !== columnName) : [...currentColumnsJson.selectedColumns, columnName]
      });
    });
  };
  const moveSelectedColumn = targetColumnIndex => {
    if (draggedColumnIndex === null || draggedColumnIndex === targetColumnIndex) return;
    setDraftColumnsJson(currentColumnsJson => {
      const selectedColumns = [...currentColumnsJson.selectedColumns];
      const [draggedColumn] = selectedColumns.splice(draggedColumnIndex, 1);
      selectedColumns.splice(targetColumnIndex, 0, draggedColumn);
      return _objectSpread(_objectSpread({}, currentColumnsJson), {}, {
        selectedColumns
      });
    });
    setDraggedColumnIndex(null);
  };
  const selectedColumnDragOver = event => {
    event.preventDefault();
  };
  const selectedColumnDragEnd = () => {
    setDraggedColumnIndex(null);
  };
  const renderSelectedColumns = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "table-column-selector__selected-columns"
    }, /*#__PURE__*/React.createElement("div", {
      className: "table-column-selector__selected-columns-title"
    }, t('selected_columns')), /*#__PURE__*/React.createElement("div", {
      className: "table-column-selector__selected-columns-list"
    }, draftColumnsJson.selectedColumns.map((columnName, columnIndex) => /*#__PURE__*/React.createElement("div", {
      className: "table-column-selector__selected-column",
      draggable: true,
      key: columnName,
      onDragEnd: selectedColumnDragEnd,
      onDragOver: selectedColumnDragOver,
      onDragStart: () => setDraggedColumnIndex(columnIndex),
      onDrop: () => moveSelectedColumn(columnIndex)
    }, t(columnName)))));
  };
  const saveColumns = () => {
    saveTableSetup(mergeColumnSelectorJson(draftColumnsJson));
  };
  if (!draftColumnsJson) return null;
  if (!columnSelectorSections) return null;
  if (!isExpanded) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "table-column-selector"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-column-selector__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-column-selector__sections"
  }, Object.entries(columnSelectorSections).map(_ref3 => {
    let [sectionName, columns] = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      className: "table-column-selector__section",
      key: sectionName
    }, /*#__PURE__*/React.createElement("div", {
      className: "table-column-selector__section-header"
    }, sectionName), /*#__PURE__*/React.createElement("div", {
      className: "table-column-selector__section-body"
    }, Object.keys(columns).map(columnName => {
      const isSelected = draftColumnsJson.selectedColumns.includes(columnName);
      const columnConfig = columnConfigByColumnName[columnName];
      const isSelectable = isColumnSelectable({
        columnConfig,
        columnParams
      });
      const isRequired = requiredColumns.includes(columnName);
      const isDisabled = isRequired || !isSelectable;
      return /*#__PURE__*/React.createElement("label", {
        className: "table-column-selector__checkbox-label".concat(isDisabled ? ' table-column-selector__checkbox-label--disabled' : ''),
        key: columnName
      }, !isSelectable && /*#__PURE__*/React.createElement(TableColumnSelectorTooltipIcon, {
        className: "table-column-selector__selectable-error-icon",
        columnName: columnName,
        icon: "error_outline",
        tooltipIdSuffix: "selectable-error",
        tooltipText: columnConfig.selectableErrorTooltipText
      }), isRequired && /*#__PURE__*/React.createElement(TableColumnSelectorTooltipIcon, {
        className: "table-column-selector__required-icon",
        columnName: columnName,
        icon: "lock",
        tooltipIdSuffix: "required",
        tooltipText: REQUIRED_COLUMN_TOOLTIP_TEXT
      }), /*#__PURE__*/React.createElement("input", {
        checked: isSelected,
        className: "table-column-selector__checkbox",
        disabled: isDisabled,
        onChange: () => toggleColumn(columnName),
        type: "checkbox"
      }), /*#__PURE__*/React.createElement("span", null, t(columnName)));
    })));
  })), renderSelectedColumns(), /*#__PURE__*/React.createElement("div", {
    className: "table-column-selector__footer"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    className: "table-column-selector__save-button",
    dataTestid: "table-column-selector-save-button",
    onClick: saveColumns,
    text: "Save",
    type: "button"
  }))));
};
const TableColumnSelectorWithConfig = props => {
  const columnSelectorConfig = useTableColumnSelectorConfig(props);
  return /*#__PURE__*/React.createElement(TableColumnSelectorContent, _extends({}, props, columnSelectorConfig));
};
const TableColumnSelector = _ref4 => {
  let {
      columnSelectorConfig = null
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  if (columnSelectorConfig) {
    return /*#__PURE__*/React.createElement(TableColumnSelectorContent, _extends({}, props, columnSelectorConfig));
  }
  return /*#__PURE__*/React.createElement(TableColumnSelectorWithConfig, props);
};
export default TableColumnSelector;